import { StatusCell } from '../../../components/status/status-cell';

export function AiReceivingPill() {
  return (
    <StatusCell variant="muted" tone="soft" weight="medium" className="gap-1">
      <span aria-hidden="true">✨</span>
      AI receiving
    </StatusCell>
  );
}
